import { render, staticRenderFns } from "./pointSetting.vue?vue&type=template&id=3d8b5eb0&"
import script from "./pointSetting.vue?vue&type=script&lang=js&"
export * from "./pointSetting.vue?vue&type=script&lang=js&"
import style0 from "./pointSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports